export enum ApplicationType {
  Admin = 'admin',
  Portal = 'portal',
  Assistant = 'assistant',
}
